import React,{useEffect, useState} from 'react'
import Head from './Head'

// echarts图表
import LineChart from './LineChart'
import RadarChart from './RadarChart'
import PieChart from './PieChart'
import BarChart from './BarChart'

// 热门列表
import VillageList from './VillageList'
import UserInfo from './UserInfo'
import ScenicList from './ScenicList'

import './css/index.min.css'
import '../../assets/fontIcon/iconfont.css'

// 获取数据
import {getHome} from '../../api/home'

import {Spin} from 'antd'

const Home = () => {
    // const {load,data} = useSelector(state=>state.home)
    const [data,setData] = useState(null)
    async function ftechHome(){
        const res =  await getHome()
        let data = res.data.data
        setData(data)
    }
    useEffect(()=>{
        ftechHome()
    },[])
    return (
        data?
        <div className="home">
            <Head headData = {data.headList}/>
            <LineChart views = {data.qtfwl} />
            {/* <div className="echartsList">
                <div className="content">
                    <RadarChart />
                </div>
                <div className="content">
                    <PieChart brigades={data.dmwh} />
                </div>
                <div className="content">
                    <BarChart sceneVillage={data.qtfwl} />
                </div>
            </div> */}
            <div className="hotList">
                <VillageList villages={data.rmjq.slice(0,9)} />
                <ScenicList scenic={data.rmcl.slice(0,9)} />
                <UserInfo />
            </div>
        </div>:null
    )
};

export default Home;